import { Property } from "../../../businessFoundation/MetaClassData/MetaClassDataList/MetaClassDataModel";

export interface UpdateParams {
    address: Address;
    inView: InView;
}

export interface DeleteParams {
    address: Address;
    inView: InView;
}

export interface Address {
    primaryKeyId: string | null;
    contactId: string | null;
    organizationId: string | null;
    addressType: AddressType[];
    name: string;
    lastName: string;
    firstName: string;
    daytimePhoneNumber: string;
    eveningPhoneNumber: string;
    email: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    countryCode: string;
    countryName: string;
    postalCode: string;
    regionCode: string;
    extendedProperties: Property[];
    isFetched: boolean;
    isNew: boolean,
    idx: number
}

export interface AddressForm {
    open: boolean;
    address: Address;
    extendedPropertyErrors: Error[];
}

export interface ConfirmDialog {
    open: boolean;
    title: string;
    message: string;
    address: Address;
}

export enum AddressType {
    Public = 1,
    Shipping = 2,
    Billing = 4,
}

export enum InView {
    None,
    Contact,
    Organization,
}
